import { InterviewTypes } from '@/utils/interviews';
import * as Styles from './InterviewEnding.styles';

type InterviewEndingProps = {
  interviewType: InterviewTypes;
};

const interviewName = {
  [InterviewTypes.PRE_SCREENING]: 'English Check',
  [InterviewTypes.TECHNICAL_CHALLENGE]: 'Technical Challenge',
};

export default function InterviewEnding({ interviewType }: InterviewEndingProps): JSX.Element {
  return (
    <div>
      <section>
        <Styles.Hero>
          <Styles.Container isSmaller>
            <Styles.CandidateGreetings>
              Thank you for submitting your {interviewName[interviewType]}!
            </Styles.CandidateGreetings>
          </Styles.Container>
        </Styles.Hero>
        <Styles.Container isSmaller>
          {interviewName[interviewType] === 'Technical Challenge' ? (
            <>
              <Styles.WelcomingText>
                We&apos;ve officially received your project and our Engineering Team will soon begin
                the revision process, which typically takes up to <strong>12 days</strong>.
                Sometimes, occasional delays can occur, often due to a high number of submissions.
                Your understanding and patience on this are truly valued!
              </Styles.WelcomingText>

              <Styles.WelcomingText>
                Our Talent X Team will keep you informed of the results once we have completed the
                evaluation. If you have any questions or need any further information, please
                don&apos;t hesitate to reach out!
              </Styles.WelcomingText>
            </>
          ) : (
            <Styles.WelcomingText>
              Our team will evaluate it and get back to you with a feedback soon.
            </Styles.WelcomingText>
          )}

          <Styles.WelcomingText isBold>Trio Talent X Team</Styles.WelcomingText>
        </Styles.Container>
      </section>
    </div>
  );
}
